export default __webpack_public_path__ + "static/media/6.6ce39c3c.jpg";